"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var isDiscount = function isDiscount(regularPrice, specialPrice) {
  return specialPrice !== null && parseFloat(specialPrice) < parseFloat(regularPrice);
};
var _default = isDiscount;
exports["default"] = _default;